import http from "@/utils/http";

const home = {
    //获取系列列表
    getDocTree: (data, loading = false) => {
        return http.post('/md/doc/tree', data, loading)
    },
    //获取doc文件的流
    getDoc: (data, callback) => {
        http.getFileArrayBuffer('/md/doc',data, callback)
    },
    //提交留言
    insertMessage: (data, loading = false) => {
        return http.post('/message',data, loading)
    },
    //更新留言
    updateMessage: (data, loading = false) => {
        return http.put('/message',data, loading)
    },
    //删除留言
    deleteMessage: (data, loading = false) => {
        return http.Delete('/message',data, loading)
    },
    //获取留言板列表
    getMessageList: (data, loading = false) => {
        return http.post('/message/list',data, loading)
    },
    //点赞或点才
    upOrDownMessage: (data, loading = false) => {
        return http.put('/message/upOrDown',data, loading)
    },
    //新增评论
    insetComment: (data, loading = false) => {
        return http.post('/comment',data, loading)
    },
    //删除评论
    deleteComment: (data, loading = false) => {
        return http.Delete('/comment',data, loading)
    },
    //更新评率
    updateComment: (data, loading = false) => {
        return http.put('/comment',data, loading)
    },
    //获取评论列表
    getCommentList: (data, loading = false) => {
        return http.post('/comment/list',data, loading)
    },
    //获取全部分组链接
    getAllLinkedList:(data, loading = false) => {
        return http.post('/linkedGroup/list/linked',data, loading)
    },
    //获取子菜单数据
    getSubLinkedList:(data, loading = false) => {
        return http.post('/linkedSub/list',data, loading)
    },
    //获取留言板列表
    getDynamicList: (data, loading = false) => {
        return http.post('/dynamic/list',data, loading)
    },
    //点赞或点才
    upOrDownDynamic: (data, loading = false) => {
        return http.put('/dynamic/upOrDown',data, loading)
    },
    //首页列表
    getMainList: (data, loading = false) => {
        return http.post('/main/list',data, loading)
    },
    //点赞或点才
    upOrDownDoc: (data, loading = false) => {
        return http.put('/md/doc/upOrDown',data, loading)
    },
}


export default home